module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-viewport"
  }, [_c('mapViewerFloatingSidemenu', {
    attrs: {
      "backgrounds": _vm.backgrounds,
      "legend": _vm.legend,
      "layers": _vm.layers,
      "layersState": _vm.layersLeaflet,
      "name": _vm.instamapsConfig.nomAplicacio,
      "legendOpen": _vm.legendOpen,
      "instamapsConfig": _vm.instamapsConfig,
      "isInIframe": _vm.isInIframe,
      "legendVisible": _vm.legendVisible
    },
    on: {
      "print": function($event) {
        _vm.printModal($event)
      },
      "printScale": function($event) {
        _vm.printScaleModal($event)
      },
      "downloadModal": function($event) {
        _vm.downloadModal()
      },
      "changeBackground": function($event) {
        _vm.updateAttribution()
      }
    }
  }), _vm._v(" "), _c('mapViewerFooterControls', {
    attrs: {
      "isInIframe": _vm.isInIframe,
      "isEnabled": !_vm.showInfoModal && !_vm.showShareModal,
      "isAtlasMode": _vm.isAtlasMode
    },
    on: {
      "reloadMap": function($event) {
        _vm.loadVisor()
      },
      "deleteMap": function($event) {
        _vm.resetMap()
      },
      "mapInfo": function($event) {
        _vm.mapInfo()
      },
      "likeMap": function($event) {
        _vm.likeMap()
      },
      "locate": function($event) {
        _vm.locate()
      },
      "deleteLocate": function($event) {
        _vm.deleteLocate()
      },
      "home": function($event) {
        _vm.home()
      },
      "share": function($event) {
        _vm.share()
      },
      "launch": function($event) {
        _vm.launch()
      }
    }
  }), _vm._v(" "), _c('mapViewerShareModal', {
    attrs: {
      "mapName": _vm.mapName,
      "show": _vm.showShareModal
    },
    on: {
      "closeShareModal": function($event) {
        _vm.closeShareModal()
      }
    }
  }), _vm._v(" "), _c('mapViewerInfoModal', {
    attrs: {
      "show": _vm.showInfoModal,
      "isAtlasMode": _vm.isAtlasMode,
      "name": _vm.instamapsConfig.nomAplicacio,
      "author": _vm.author,
      "mapOptions": _vm.instamapsConfig.options,
      "lastUpdated": _vm.dataActualitzacio,
      "creationDate": _vm.dataCreacio,
      "attribution": _vm.attribution
    },
    on: {
      "closeInfoModal": function($event) {
        _vm.closeInfoModal()
      }
    }
  }), _vm._v(" "), _c('mapViewerPinModal', {
    attrs: {
      "show": _vm.showPinModal,
      "pins": _vm.pinModalPins
    },
    on: {
      "closePinModal": function($event) {
        _vm.closePinModal()
      }
    }
  }), _vm._v(" "), _c('mapViewerPrintModal', {
    attrs: {
      "show": _vm.showPrintModal,
      "imageUrl": _vm.printModalImageUrl,
      "name": _vm.instamapsConfig.nomAplicacio,
      "author": _vm.author
    },
    on: {
      "closePrintModal": function($event) {
        _vm.closePrintModal()
      }
    }
  }), _vm._v(" "), _c('mapViewerPrintScaleModal', {
    attrs: {
      "show": _vm.showPrintScaleModal,
      "printScaleModalUrl": _vm.printScaleModalUrl
    },
    on: {
      "closePrintScaleModal": function($event) {
        _vm.closePrintScaleModal()
      }
    }
  }), _vm._v(" "), _c('mapViewerPasswordModal', {
    attrs: {
      "show": _vm.showPasswordModal
    },
    on: {
      "loadConfig": _vm.loadMapConfig
    }
  }), _vm._v(" "), _c('mapViewerDownloadModal', {
    attrs: {
      "show": _vm.showDownloadModal,
      "layersItem": _vm.layersItem
    },
    on: {
      "closeDownloadModal": function($event) {
        _vm.closeDownloadModal()
      }
    }
  }), _vm._v(" "), _c('mapViewerDataTableModal', {
    attrs: {
      "show": _vm.showDataTableModal
    },
    on: {
      "closeDataTableModal": function($event) {
        _vm.closeDataTableModal()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f74fb50c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/map-viewer/map-viewer.vue
// module id = 138
// module chunks = 0